import { render, staticRenderFns } from "./CampaignStatsTable.vue?vue&type=template&id=46cab2d0&scoped=true&"
import script from "./CampaignStatsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatsTable.vue?vue&type=style&index=0&id=46cab2d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cab2d0",
  null
  
)

export default component.exports